import React, {useEffect, useMemo, useState} from 'react';
import PieChart from '../../charts/PieChart'
import BlockChart from "../../BlockChart";
import {useTranslation} from "react-i18next";


const ConsentRequestByRankChart = ( {data = [], isSuccess, isFetching: isLoading, refetch} ) => {

  const { t } = useTranslation();
  const formatData = (data) => (
    data.map((el) => ({
      name: el.display_rank,
      y: el.count
    }))
  )
  const formattedData = useMemo(() => (formatData(data)), [data])

  return (
    <BlockChart title={t("cmp.analytics.consentRequestsByRank")} isLoading={isLoading} isSuccess={isSuccess}>
      <PieChart data={formattedData}/>
    </BlockChart>
  )
}

export default ConsentRequestByRankChart
